/* Editor capability presets — PURE, no TipTap import.
 *
 * Kept free of TipTap on purpose: @tiptap/pm ships untransformed ESM that CRA's
 * jest will not transform, so anything importing it is untestable in unit tests.
 * The same split the repo already uses for songNotesModel.js (logic) vs
 * SongNotesService.js (I/O).
 *
 * Capabilities gate EXTENSIONS, not just UI — a capability that is off means the
 * node is never registered in the schema, so a reduced mount cannot produce a
 * block a plainer surface would fail to render.
 *
 * The PLAIN set is the default everywhere: a new mount is conservative until it
 * opts in, so slash commands can never be shipped to a family-facing surface by
 * accident (Lesson Recap tiers stay plain rich text, by decision).
 */

export const CAPABILITIES_PLAIN = {
	slashCommands: false,
	mentions: false,
	toc: false,
	tasks: false,
	callout: false,
	tables: false,
	childPages: false,
	script: false,
	// Off here for the same conservative reason as the rest: a family-facing
	// Recap tier should not silently restructure what a teacher pasted.
	markdownPaste: false,
};

export const CAPABILITIES_DOCS = {
	slashCommands: true,
	mentions: true,
	toc: true,
	tasks: true,
	callout: true,
	tables: true,
	childPages: true,
	/* Pasted markdown SOURCE becomes real blocks. Typed markdown already worked
	   (StarterKit input rules); input rules never fire on paste, which is why
	   this is a separate capability rather than free. See markdownPaste.js. */
	markdownPaste: true,
	// Off by default even here: the script elements rebind Tab and Enter, and a
	// planning doc that silently retyped a line on Tab would be baffling. A doc
	// opts in by BEING a script (see CAPABILITIES_SCRIPT).
	script: false,
};

/* Script docs — everything Docs can do, plus the six script elements and the
   Tab/Enter element flow. A superset rather than a separate world: a script is
   still a doc, so tables, callouts and sub-pages keep working inside one (a
   rehearsal schedule pasted into the back of a script is a real thing). */
export const CAPABILITIES_SCRIPT = {
	...CAPABILITIES_DOCS,
	script: true,
};
